import React from 'react';
import PropTypes from 'prop-types';
import {Box, Heading} from '@tenancy.nz/ui';

function SectionHeader({heading, subheading = undefined}) {
  return (
    <Box
      as="header"
      sx={{display: 'flex', flexDirection: 'column', gap: 2, mb: 4}}>
      <Heading as="h1">{heading}</Heading>
      {subheading && (
        <Heading as="h3" sx={{mt: '-10px'}}>
          {subheading}
        </Heading>
      )}
    </Box>
  );
}

SectionHeader.propTypes = {
  heading: PropTypes.node.isRequired,
  subheading: PropTypes.node,
};

export default SectionHeader;
